import React from 'react';
import styled from 'styled-components';

import Viclogo from 'components/Icons/Viclogo';
import colors from 'utils/colors';
import device from 'utils/device';

export type ComponentProps = object;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  color: ${colors.white};
  padding: 60px 20px 40px;
  align-items: baseline;

  @media ${device.isTablet} {
    width: 95vw;
    padding: 3rem 0;
    justify-content: flex-end;
    align-items: center;
  }

  @media ${device.isDesktop} {
    width: 960px;
    margin: auto;
    padding: 3rem;
    align-items: center;
    justify-content: flex-end;
  }
`;

const Text = styled.div`
  color: ${colors.white};
  font-size: 14px;
  transform: translateY(-4px);

  @media ${device.isTablet} {
    padding-right: 40px;
    font-size: inherit;
  }

  @media ${device.isDesktop} {
    padding-right: 60px;
  }
`;

const LogoHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 61.22px;
  transform: translateY(-3px);

  @media ${device.isTablet} {
    height: 61.015px;
  }

  @media ${device.isMobile} {
    transform: translateY(-13px);
    align-self: flex-start;
  }
`;

const Anchor = styled.a`
  width: 100%;
  height: 100%;
`;

const Footer: React.FC<ComponentProps> = () => {
  return (
    <Wrapper>
      <Text>© State Government of Victoria {new Date().getFullYear()}</Text>
      <LogoHolder>
        <Anchor
          href='https://www.vic.gov.au'
          aria-label='Go to State Government of Victoria website'>
          <Viclogo fill='white' />
        </Anchor>
      </LogoHolder>
    </Wrapper>
  );
};

export default Footer;
